import { MainRoutes } from "./routes";

export const App = () => {
  return <MainRoutes />;
};
